import * as React from "react";
import { AccessoriesCTACaption } from "../../../../../components/modules/EcommContent/AccessoriesEcommContent/components/AccessoriesCTA/components/AccessoriesCTACaption.js";
import { useAccessoriesEcommContext } from "../../../../../../../context/modules/EcommContent/AccessoriesEcommContent/context/AccessoriesEcommContext.js";
import { ProductDetailCTA } from "../../../../../../../../components/CTAs/ProductDetailCTA/modules/EcommContent/components/CTAs/ProductDetailCTA/ProductDetailCTA.js";
import { useProductData } from "../../../../../../../../../../context/context/product-context-hooks.js";
const AccessoriesCTA = () => {
  const {
    activeVariant: { channelAvailability, sku }
  } = useProductData();
  const { quantity } = useAccessoriesEcommContext();
  const handleConversionEvent = React.useCallback(() => {
  }, []);
  const onAddToCartSuccess = React.useCallback(() => {
  }, []);
  const productAction = channelAvailability === "ONLINE" ? "ADD_TO_CART" : "ADD_TO_CART_UNAVAILABLE";
  return /* @__PURE__ */ React.createElement(
    ProductDetailCTA,
    {
      action: productAction,
      handleConversionEvent,
      addToCartConfig: {
        activeSku: sku,
        onSuccess: onAddToCartSuccess,
        quantity,
        caption: /* @__PURE__ */ React.createElement(AccessoriesCTACaption, null)
      }
    }
  );
};
export {
  AccessoriesCTA
};
//# sourceMappingURL=AccessoriesCTA.js.map
